import { Scissors, Star, Check } from "lucide-react";

const BRL = (v) => v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export default function Services({ services, selected, onToggle }) {
  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="mx-auto max-w-md px-4 py-14 md:max-w-2xl lg:max-w-4xl"
    >
      <span className="eyebrow">Nossos Serviços</span>
      <h2 className="font-display mt-2 text-4xl text-amber-100 sm:text-5xl">
        Navalha afiada, preço justo
      </h2>
      <p className="mt-3 text-sm text-zinc-400">
        Terça a sábado, das 9h às 20h. Escolha um ou mais serviços para já iniciar o agendamento.
      </p>

      <div className="mt-8 space-y-3 md:grid md:grid-cols-2 md:gap-4 md:space-y-0">
        {services.map((s, i) => (
          <div
            key={s.id}
            data-testid={`service-item-${s.id}`}
            className={`group animate-fade-up rounded-xl border p-5 transition-all ${
              selected.includes(s.id)
                ? "border-amber-500/70 bg-amber-500/5"
                : "border-amber-500/15 bg-[#161618] hover:border-amber-500/50 hover:bg-[#1f1f23]"
            }`}
            style={{ animationDelay: `${i * 0.08}s` }}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-amber-500/30 bg-amber-500/10">
                  <Scissors className="h-4 w-4 text-amber-400" />
                </span>
                <div>
                  <h3 className="text-base font-semibold text-amber-200/90">{s.name}</h3>
                  <p className="text-xs text-zinc-500">{s.duration}</p>
                </div>
              </div>
              {s.popular && (
                <span
                  data-testid="service-popular-badge"
                  className="flex items-center gap-1 rounded-full bg-amber-500/15 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-amber-400"
                >
                  <Star className="h-3 w-3 fill-amber-400" /> Popular
                </span>
              )}
            </div>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">{s.description}</p>
            <div className="mt-4 flex items-center justify-between">
              <span className="font-display text-2xl text-amber-400">{BRL(s.price)}</span>
              <button
                data-testid={`service-select-button-${s.id}`}
                onClick={() => onToggle(s.id)}
                className={`flex items-center gap-1.5 rounded-full border px-4 py-2 text-xs font-bold uppercase tracking-wider transition-all active:scale-95 ${
                  selected.includes(s.id)
                    ? "border-amber-500 bg-amber-500 text-zinc-950"
                    : "border-amber-500/40 text-amber-300 hover:bg-amber-500 hover:text-zinc-950"
                }`}
              >
                {selected.includes(s.id) && <Check className="h-3.5 w-3.5" />}
                {selected.includes(s.id) ? "Selecionado" : "Selecionar"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
